import { gql } from '@apollo/client';

export default gql`
    query($offset: Int!, $admin: String){
        GenreLimit(offset: $offset, admin: $admin) {
            IdGenero
            Genero
        }
    }
`;